import { render, staticRenderFns } from "./personality-info.vue?vue&type=template&id=005840d8&"
import script from "./personality-info.vue?vue&type=script&lang=js&"
export * from "./personality-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports